module.exports = __webpack_public_path__ + "static/img/account_active.960ae94b.png";